<template>
  <div>
    <q-select
      dense
      outlined
      :model-value="props.modelValue"
      @update:model-value="onPerfilChange"
      :options="listaPerfil"
      option-label="display_name"
      option-value="id"
      label="Selecione o Perfil"
      :bg-color="disable ? 'grey-3' : ''"
      :disable="disable"
      label-color="grey-6"
      behavior="menu"
      map-options
      hide-bottom-space
      :able-colspan="12"
      :stack-label="true"
      use-input
      :rules="validacao ? [(val) => val || 'Campo Obrigatório'] : []"
      @filter="filtrar"
      :display-value="
        modelValue?.display_name?.length > 9
          ? `${modelValue?.display_name?.substring(0, 9)}....`
          : modelValue?.display_name
      "
    >
      <template v-slot:append>
        <q-btn
          flat
          round
          color="negative"
          icon="sym_o_close"
          size="md"
          :disable="!modelValue || !modelValue.id"
          @click.stop="removerPerfilDialog = true"
        >
          <q-tooltip>Remover Perfil</q-tooltip>
        </q-btn>
      </template>
      <template v-slot:no-option>
        <q-item>
          <q-item-section>Nenhum resultado</q-item-section>
        </q-item>
      </template>
    </q-select>

    <dialog-info-design
      mensagem="Remover Perfil?"
      subMensagem="Tem certeza que deseja remover o perfil do usuário?"
      :exibir="removerPerfilDialog"
      :showCancelar="true"
      @resultado="removerPerfilUsuario"
    />
  </div>
</template>

<script setup>
// @TODO Alterar para usar o "defineModel" das ultimas versões do vue
import { /*defineModel*/ ref, defineProps, defineEmits, inject } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import DialogInfoDesign from "../../../components/DialogInfoDesign.vue";

const store = useStore();
const $q = useQuasar();
const emit = defineEmits(["update:modelValue"]);

const userId = inject("userId", null);

const props = defineProps({
  modelValue: {},
  disable: {
    type: Boolean,
  },
  validacao: {
    type: Boolean,
    default: false,
  },
});

const listaPerfil = ref([]);
const removerPerfilDialog = ref(false);

const listarPerfis = async (val) => {
  listaPerfil.value = [];
  try {
    let response = await store.dispatch("user/getRoles");
    if (
      store.state.autenticacao.cliente.includes("staging-multpex") ||
      store.state.autenticacao.cliente.includes("multpex")
    ) {
      listaPerfil.value = response.data.results.data;

      listaPerfil.value = listaPerfil.value.filter(
        (v) => v.display_name.toLowerCase().indexOf(val.toLowerCase()) > -1
      );
      return;
    }
    listaPerfil.value = response.data.results.data.filter((value) => {
      if (value.name != "admin" && value.name != "tablet") {
        return value.display_name.toLowerCase().indexOf(val.toLowerCase()) > -1;
      }
    });
  } catch (error) {
    console.log(error);
  }
};

const filtrar = async (val, update) => {
  await listarPerfis(val);
  update();
};

const onPerfilChange = async (value) => {
  emit("update:modelValue", value);

  if (userId && value && value.id) {
    try {
      await store.dispatch("simplificadoStore/atribuirPerfil", {
        user_id: userId.value,
        role_id: value.id,
      });

      $q.notify({
        message: "Perfil atribuído com sucesso",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {},
          },
        ],
      });
    } catch (error) {
      console.error("Erro ao atribuir perfil:", error);
      $q.notify({
        message: "Erro ao atribuir perfil",
        color: "negative",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {},
          },
        ],
      });
    }
  }
};

const removerPerfilUsuario = async (resultado) => {
  removerPerfilDialog.value = false;

  if (resultado && userId && props.modelValue && props.modelValue.id) {
    try {
      await store.dispatch("simplificadoStore/removerPerfil", {
        user_id: userId.value,
        role_id: props.modelValue.id,
      });

      emit("update:modelValue", null);

      $q.notify({
        message: "Perfil removido com sucesso",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {},
          },
        ],
      });
    } catch (error) {
      console.error("Erro ao remover perfil:", error);
      $q.notify({
        message: "Erro ao remover perfil",
        color: "negative",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {},
          },
        ],
      });
    }
  }
};
</script>

<style scoped>
.q-field {
  overflow: hidden;
  white-space: no-wrap;
}
</style>
